export default __webpack_public_path__ + "locales/az/DeleteDialog.json?hash=f436679ac3906c49860402bf60452380";